import React from 'react'
import { Helmet } from 'react-helmet'
import HeaderCustomerPreview from '../../layout/header/HeaderCustomerPreview'
import { useTranslation } from 'react-i18next';
import TermsAndCondition from '../new-booking-form/components/terms-and-condition/TermsAndCondition';
import Loader from '../../components/Loader';
import { useSelector } from 'react-redux';

const TermsAndConditionsPreview = () => {
  const { t } = useTranslation("common");
  const { isLoading } = useSelector((state) => state?.newBookingForm);
    
  return (
    <>
      {isLoading && <Loader isLoading={isLoading} />}
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <HeaderCustomerPreview title={t("preview.termsAndConditions")} />

      <div className="CustomerPreviewWrapper">    
        <TermsAndCondition isPreview />
      </div>
    </>
  )
}

export default TermsAndConditionsPreview